/**
 * Save result that outlives the form. A panel that closes on success must not be the only place
 * the result was shown.
 */
import { useSyncExternalStore } from "react";

export type NoticeTone = "saving" | "saved" | "failed";

export interface Notice {
  readonly tone: NoticeTone;
  readonly text: string;
  readonly revision: number;
}

let current: Notice | null = null;

let revision = 0;

const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function publishNotice(tone: NoticeTone, text: string): void {
  revision += 1;
  current = { tone, text, revision };
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);

  return () => listeners.delete(listener);
}

export function useNotice(): Notice | null {
  return useSyncExternalStore(subscribe, () => current);
}
